export function toIso(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function parseIso(s: string): Date {
  return new Date(s + 'T00:00:00Z');
}

// Local-midnight Date from 'YYYY-MM-DD'. Used by VueDatePicker bindings to
// avoid timezone shifts (the picker stores local-midnight Dates and would
// drift by a day if we used UTC midnight).
export function parseIsoLocal(s: string | null | undefined): Date | null {
  if (!s) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

export function addDays(input: string | Date, days: number): string {
  const d = typeof input === 'string' ? parseIso(input) : new Date(input.getTime());
  d.setUTCDate(d.getUTCDate() + days);
  return toIso(d);
}

// Extract YYYY-MM-DD from a Date using LOCAL getters — use this when the
// Date came from v-calendar (which constructs local-midnight Dates) so the
// calendar day the user clicked matches the ISO string we send to the API.
export function toIsoLocal(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function formatLocale(iso: string, locale: string): string {
  return parseIso(iso).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

// DD/MM/YYYY display format used across the app (pickers, admin table).
// Accepts 'YYYY-MM-DD' or 'YYYY-MM-DD HH:MM:SS' and ignores trailing time.
export function formatDMY(iso: string | null | undefined): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${m[3]}/${m[2]}/${m[1]}`;
}

// DD.MM.YYYY — dots variant. Used in /admin/bookings table where dots are
// visually quieter and align with the European date convention operators
// expect when scanning a list.
export function formatDMYDot(iso: string | null | undefined): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${m[3]}.${m[2]}.${m[1]}`;
}
